import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PermissionRefreshCoordinator } from '@hta/auth';

/**
 * Suscribe al coordinator de invalidación de permisos y muestra un toast
 * cuando otra pestaña (del mismo origin) notifica cambios. Se instancia 1 vez
 * en el shell de la app mediante el APP_INITIALIZER `providePermissionInvalidationListener`.
 */
@Injectable({ providedIn: 'root' })
export class PermissionInvalidationUiBridge implements OnDestroy {
  private readonly coordinator = inject(PermissionRefreshCoordinator);
  private readonly snack = inject(MatSnackBar);
  private readonly cleanup?: () => void;

  constructor() {
    this.cleanup = this.coordinator.onInvalidated(() => {
      this.snack.open(
        'Permisos actualizados desde otra pestaña',
        'Cerrar',
        { duration: 4000, horizontalPosition: 'right', verticalPosition: 'bottom' }
      );
    });
  }

  ngOnDestroy(): void {
    this.cleanup?.();
  }
}
